import PropTypes from 'prop-types'
import StarRatingsShape from './star_ratings'

const reviewCountsShape = PropTypes.shape({
  1: PropTypes.number,
  2: PropTypes.number,
  3: PropTypes.number,
  4: PropTypes.number,
  5: PropTypes.number
})

export default PropTypes.shape({
  rating: PropTypes.number.isRequired,
  review_count: PropTypes.number.isRequired,
  review_counts: reviewCountsShape.isRequired,
  star_ratings: StarRatingsShape.isRequired,
  visible_review_count: PropTypes.number.isRequired,
  review_replies_count: PropTypes.number.isRequired
})
